import { useCallback, useState } from 'react';
import { LocationType } from '../../../enum';
export function resolveTotalSeats(unlimitedSeats, totalSeats) {
  if (unlimitedSeats) return null;
  if (typeof totalSeats === 'number') return totalSeats;
  return 1;
}
export function useLocationFormState() {
  var _a = useState(''),
    address = _a[0],
    setAddress = _a[1];
  var _b = useState(''),
    locationName = _b[0],
    setLocationName = _b[1];
  var _c = useState(LocationType.InHouse),
    locationType = _c[0],
    setLocationType = _c[1];
  var _d = useState(true),
    unlimitedSeats = _d[0],
    setUnlimitedSeats = _d[1];
  var _e = useState(''),
    totalSeats = _e[0],
    setTotalSeats = _e[1];
  var _f = useState(''),
    city = _f[0],
    setCity = _f[1];
  var _g = useState(''),
    region = _g[0],
    setRegion = _g[1];
  var _h = useState(''),
    stateProvince = _h[0],
    setStateProvince = _h[1];
  var _j = useState(null),
    stateProvinceCode = _j[0],
    setStateProvinceCode = _j[1];
  var _k = useState(''),
    countryName = _k[0],
    setCountryName = _k[1];
  var _l = useState(null),
    countryCode = _l[0],
    setCountryCode = _l[1];
  var _m = useState(false),
    addressCountryResolved = _m[0],
    setAddressCountryResolved = _m[1];
  var _o = useState(null),
    latitude = _o[0],
    setLatitude = _o[1];
  var _p = useState(null),
    longitude = _p[0],
    setLongitude = _p[1];
  var resetAddressFields = useCallback(function () {
    setAddress('');
    setLocationName('');
    setCity('');
    setRegion('');
    setStateProvince('');
    setStateProvinceCode(null);
    setCountryName('');
    setCountryCode(null);
    setAddressCountryResolved(false);
    setLatitude(null);
    setLongitude(null);
    setUnlimitedSeats(true);
    setTotalSeats('');
    setLocationType(LocationType.InHouse);
  }, []);
  return {
    address: address,
    setAddress: setAddress,
    locationName: locationName,
    setLocationName: setLocationName,
    locationType: locationType,
    setLocationType: setLocationType,
    unlimitedSeats: unlimitedSeats,
    setUnlimitedSeats: setUnlimitedSeats,
    totalSeats: totalSeats,
    setTotalSeats: setTotalSeats,
    city: city,
    setCity: setCity,
    region: region,
    setRegion: setRegion,
    stateProvince: stateProvince,
    setStateProvince: setStateProvince,
    stateProvinceCode: stateProvinceCode,
    setStateProvinceCode: setStateProvinceCode,
    countryName: countryName,
    setCountryName: setCountryName,
    countryCode: countryCode,
    setCountryCode: setCountryCode,
    addressCountryResolved: addressCountryResolved,
    setAddressCountryResolved: setAddressCountryResolved,
    latitude: latitude,
    setLatitude: setLatitude,
    longitude: longitude,
    setLongitude: setLongitude,
    resetAddressFields: resetAddressFields
  };
}